/**
 * MapTiler configuration. API key and custom style URLs come from runtime config
 * (NUXT_PUBLIC_MAPTILER_*). Custom FAB style is configured in the MapTiler admin panel.
 */

/** @param {[number, number, number, number] | undefined} bounds [west, south, east, north] */
export function hasValidMapBounds(bounds) {
  if (!bounds || bounds.length !== 4) {
    return false;
  }

  const [west, south, east, north] = bounds;

  return [west, south, east, north].every(Number.isFinite)
    && west <= east
    && south <= north;
}

export default {
  fitBoundsOptions: {
    maxZoom: 15,
    padding: {
      top: 50,
      bottom: 30,
      left: 50,
      right: 50,
    },
  },
  /** Default map id for static image API (PDP preview, etc.) */
  staticMapId: 'streets-v2',
  staticImageApiBase: 'https://api.maptiler.com/maps/',
};
